import { render, staticRenderFns } from "./LimitExceeded.vue?vue&type=template&id=da26159c&"
var script = {}
import style0 from "./LimitExceeded.vue?vue&type=style&index=0&id=da26159c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports